/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetLocationRateByCodeResponse } from './getLocationRateByCodeResponse';
import { PricingType } from './pricingType';
import { GetLocationByCodePaymentGatewaySetting } from './getLocationByCodePaymentGatewaySetting';


export interface GetLocationByCodeResponse { 
    id?: number;
    code?: string | null;
    name?: string | null;
    address?: string | null;
    phoneNumber?: string | null;
    taxType?: PricingType;
    tax?: number;
    serviceFeeType?: PricingType;
    serviceFee?: number;
    timeZoneId?: string | null;
    locationRates?: Array<GetLocationRateByCodeResponse> | null;
    bannerImage?: string | null;
    locationPaymentGatewaySetting?: GetLocationByCodePaymentGatewaySetting;
}
export namespace GetLocationByCodeResponse {
}


